import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingSpinner = ({ message = 'กำลังโหลดข้อมูล...' }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      flexDirection="column"
    >
      <CircularProgress size={50} thickness={4} />
      <Typography
        variant="body1"
        color="textSecondary"
        sx={{ marginTop: 2.5 }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;
